import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { ReactNode } from 'react';

interface ServiceCardProps {
  title: string;
  tagline: string;
  description: string;
  link: string;
  icon: ReactNode;
}

const ServiceCard = ({ title, tagline, description, link, icon }: ServiceCardProps) => {
  return (
    <div className="bg-white rounded-lg shadow-md p-8 hover:shadow-xl transition-all duration-300 border-t-4 border-transparent hover:border-gold-500 group h-full flex flex-col">
      <div className="mb-6 p-4 bg-navy-50 rounded-full w-16 h-16 flex items-center justify-center text-navy-600 group-hover:bg-navy-600 group-hover:text-white transition-colors duration-300">
        {icon}
      </div>
      
      <h3 className="text-xl font-bold text-navy-900 mb-2 font-serif">{title}</h3>
      <p className="text-sm text-teal-600 font-medium mb-4 uppercase tracking-wide">{tagline}</p>
      <p className="text-gray-600 mb-6 flex-grow leading-relaxed">{description}</p>
      
      <Link 
        to={link} 
        className="inline-flex items-center text-navy-600 font-semibold hover:text-gold-600 transition-colors mt-auto group-hover:translate-x-1 duration-300"
      >
        Learn More <ArrowRight className="ml-2 h-4 w-4" />
      </Link>
    </div>
  );
};

export default ServiceCard;
